module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-table"
  }, [(!_vm.loading) ? _c('report-forms-and-filters', {
    attrs: {
      "reportData": _vm.parsedReportData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.generating) ? [_c('div', {
    staticClass: "generating-msg"
  }, [_c('vue-spinner'), _vm._v(" "), _c('small', [_vm._v("Generating full report, please wait...")])], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vgt-responsive",
    class: {
      'loading': _vm.loading
    }
  }, [_c('vue-spinner', {
    staticStyle: {
      "margin": "0 auto"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "vgt-table bordered"
  }, [_c('thead', [_c('tr', [(_vm.columns && _vm.columns.length) ? _c('th', [_vm._v("#")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(col) {
    return _c('th', {
      class: {
        'sorting': !_vm.generating && !_vm.report.isPreview
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.onSortChange(col.field)
        }
      }
    }, [_vm._v(_vm._s(col.label))])])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, rowIdx) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(rowIdx + _vm.resultsOffset + 1))]), _vm._v(" "), _vm._l((row), function(td, tdIdx) {
      return [(!_vm.isReportColumnHidden(tdIdx)) ? _c('td', [(_vm.specialReportColumnTypeComponents[_vm.getFieldTypeFromFieldName(tdIdx)]) ? _c('div', [_c(_vm.specialReportColumnTypeComponents[_vm.getFieldTypeFromFieldName(tdIdx)], {
        tag: "component",
        attrs: {
          "data": {
            td: td,
            form_data: _vm.rowsFormData[rowIdx][_vm.getFormIdFromReportRowKey(tdIdx)]
          },
          "settings": _vm.columnSettings[tdIdx.split('_')[1]]
        }
      })], 1) : (_vm.filesColumns.includes(tdIdx)) ? _c('span', {
        staticClass: "td-file-download",
        domProps: {
          "innerHTML": _vm._s(_vm.makeLink(tdIdx, td))
        }
      }, [_vm._v(_vm._s(td))]) : (_vm.datesColumns.includes(tdIdx)) ? [_vm._v(_vm._s(_vm._f("formatDateModalNoTimeZone")(td)))] : (_vm.dateTimeColumns.includes(tdIdx)) ? [_vm._v(_vm._s(_vm.dateTimeColumnFormat(td)))] : [_vm._v(_vm._s(td))]], 2) : _vm._e()]
    })], 2)
  }), 0)])], 1), _vm._v(" "), (Object.keys(_vm.report).length) ? _c('div', {
    staticClass: "vgt-wrap__footer vgt-clearfix"
  }, [(_vm.generating) ? [_vm._v("\n      Generating full report, please wait...\n      "), _c('vue-spinner')] : _vm._e(), _vm._v(" "), (!_vm.generating && !_vm.report.isPreview) ? [_c('div', {
    staticClass: "footer__row-count vgt-pull-left"
  }, [_c('span', {
    staticClass: "footer__row-count__label"
  }, [_vm._v("Rows per page")]), _vm._v(" "), _c('select', {
    staticClass: "footer__row-count__select",
    attrs: {
      "autocomplete": "off",
      "name": "perPageSelect"
    },
    on: {
      "change": _vm.onPerPageChange
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    },
    domProps: {
      "selected": _vm.resultsPerPage == 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    },
    domProps: {
      "selected": _vm.resultsPerPage == 25
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    },
    domProps: {
      "selected": _vm.resultsPerPage == 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    },
    domProps: {
      "selected": _vm.resultsPerPage == 100
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "250"
    },
    domProps: {
      "selected": _vm.resultsPerPage == 250
    }
  }, [_vm._v("250")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "500"
    },
    domProps: {
      "selected": _vm.resultsPerPage == 500
    }
  }, [_vm._v("500")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    },
    domProps: {
      "selected": _vm.resultsPerPage == 0
    }
  }, [_vm._v("All")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer__navigation vgt-pull-right"
  }, [_c('a', {
    staticClass: "footer__navigation__page-btn",
    class: {
      'disabled': _vm.resultsOffset == 0
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('span', {
    staticClass: "chevron left"
  }), _c('span', [_vm._v("Prev")])]), _vm._v(" "), _c('div', {
    staticClass: "footer__navigation__info"
  }, [_vm._v(_vm._s((_vm.report.count ? _vm.resultsOffset + 1 : 0)) + " - " + _vm._s(_vm.visibleRowsCount) + " of " + _vm._s(_vm.report.count))]), _vm._v(" "), _c('a', {
    staticClass: "footer__navigation__page-btn",
    class: {
      'disabled': (_vm.resultsOffset + 1 + _vm.resultsPerPage > _vm.report.count) || (_vm.report.count <= _vm.resultsLimit) || _vm.resultsLimit === 0
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('span', [_vm._v("Next")]), _vm._v(" "), _c('span', {
    staticClass: "chevron right"
  })])])] : _vm._e(), _vm._v(" "), (_vm.report.isPreview && !_vm.generating) ? [_vm._v("Report Preview only displays top results. Click Finish to generate report.")] : _vm._e()], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-685da896","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/ReportTable.vue
// module id = 1679
// module chunks = 1